import { Form, Input } from 'antd';
import type { Rule } from 'rc-field-form/lib/interface';
import React, { useEffect, useRef } from 'react';

import { BUFFER_INPUT_DELAY } from '../const';

export interface FieldOutInputBufferProps {
    nameField: string;
    disabled?: boolean;
    labelField?: string;
    rulesField?: Rule[];
}

interface FieldInputBufferProps extends FieldOutInputBufferProps {
    inputComponents: (onChange: (e: any) => void, valueField?: string) => React.ReactNode;
}

const FieldInputBuffer: React.FC<FieldInputBufferProps> = ({ nameField, labelField, inputComponents, rulesField }) => {
    const form = Form.useFormInstance();

    const [valueField, setValueField] = React.useState<string>();
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const descriptionFromForm = Form.useWatch(nameField, { form, preserve: true });

    useEffect(() => {
        setValueField(descriptionFromForm || '');
    }, [descriptionFromForm]);

    useEffect(() => {
        if (valueField === undefined) return;

        if (timeoutRef?.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            form.setFieldValue(nameField, valueField);
        }, BUFFER_INPUT_DELAY);
    }, [valueField]);

    const onChange = (e: any) => {
        setValueField(e && e.target ? e.target.value : e);
    };

    return (
        <>
            <Form.Item label={labelField} rules={rulesField}>
                {inputComponents(onChange, valueField)}
            </Form.Item>
            <Form.Item hidden name={nameField}>
                <Input />
            </Form.Item>
        </>
    );
};

export default React.memo(FieldInputBuffer);
